// extracted by mini-css-extract-plugin
module.exports = {"TermsConditions":"styles_TermsConditions__dK3in"};